export default function footer() {
  return (
    <footer
      data-aos="fade-up"
      data-aos-duration="2000"
      data-aos-once="true"
      className="footermin  bg-black text-orange-500 font-displayfont justify-center text-center py-2 mt-5 md:mt-48 "
    >
      <p>
        &copy; <span className="text-white">B</span>V{" "}
        <span className="text-white">_</span> code|
        <span className="text-white">(</span>2024
        <span className="text-white">)</span>
      </p>
    </footer>
  );
}
